export default {
  EVENTS: {
    PRODUCTS: {
      // Fetch countries for mobile operations
      FETCH_COUNTRIES: 'products.fetch_countries',
      FETCH_COUNTRIES_SUCCESS: 'products.fetch_countries_success',
      FETCH_COUNTRIES_ERROR: 'products.fetch_countries_error',

      // Fetch operators by country and type
      FETCH_OPERATORS: 'products.fetch_operators',
      FETCH_OPERATORS_SUCCESS: 'products.fetch_operators_success',
      FETCH_OPERATORS_ERROR: 'products.fetch_operators_error',

      // Buy airtime/data/bundle
      BUY_MOBILE: 'products.buy_mobile',
      BUY_MOBILE_SUCCESS: 'products.buy_mobile_success',
      BUY_MOBILE_ERROR: 'products.buy_mobile_error'
    }
  },
  ENDPOINTS: {
    PRODUCTS: {
      BASE: 'https://payment.sumremit.com',
      COUNTRIES: '/mobile-operation/countries',
      OPERATORS: '/mobile-operation/operatorsByCountry/{countryCode}',
      BUY: '/mobile-operation/topup'
    },
    PARAMS: '?group=ecoxurf',
    TYPES: {
      AIRTIME: 'airtime',
      DATA: 'data',
      BUNDLE: 'bundle'
    }
  },
  OPERATION_TYPES: {
    AIRTIME: 'airtime',
    DATA: 'databundle',
    BUNDLE: 'carrierbundle'
  }
};
